

if (window.innerWidth > 1023) {

    $(document).ready(function() {
        $('.parallax-img').each(function (i, el) {
            $(el).find('.parallax-window').parallax({
                naturalWidth: $(el).attr('data-width'),
                naturalHeight: $(el).attr('data-height'),
                imageSrc: $(el).attr('data-src'),
            });
        })
        //  !!!! ATENCION !!!!
        // TODO: esto lo peta todo (el menu en home page), maxima atencion con los intervals
        //  ---------- ISFLAT ----------------
        // setInterval(function(){ $(window).trigger('resize').trigger('scroll'); }, 1000);
    })

}